import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as MessagingActions from './messaging.actions';
import { CommunicationService, ResendMessagesRequest, ResendSingleMessageRequest } from '@gms/communication-api';

@Injectable()
export class MessagingEffects {
  constructor(private actions$: Actions, private communicationService: CommunicationService) {}

  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessagingActions.loadMessages),
      mergeMap(action => {
        const params = action.params || {};
        return this.communicationService.getMessages(
          params.pageSize,
          params.pageNumber,
          params.sortBy,
          params.tspId,
          params.entityId,
          params.sentBefore,
          params.sentAfter,
          params.subject,
          params.communicationTypeId,
          params.statusId,
          params.notificationType
        ).pipe(
          map(collection => MessagingActions.loadMessagesSuccess({ collection })),
          catchError(error => of(MessagingActions.loadMessagesFailure({ error })))
        );
      })
    )
  );

  loadMessageContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessagingActions.loadMessageContent),
      mergeMap(action =>
        this.communicationService.getMessageContent(action.id).pipe(
          map(content => MessagingActions.loadMessageContentSuccess({ id: action.id, content })),
          catchError(error => of(MessagingActions.loadMessageContentFailure({ id: action.id, error })))
        )
      )
    )
  );
    getAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessagingActions.getAttachment),
      mergeMap(action =>
        this.communicationService.getAttachment(action.messageHeaderId, action.attachmentFileName).pipe(
          map(blob => MessagingActions.getAttachmentSuccess({ messageHeaderId: action.messageHeaderId, attachmentFileName: action.attachmentFileName, blob })),
          catchError(error => of(MessagingActions.getAttachmentFailure({ messageHeaderId: action.messageHeaderId, attachmentFileName: action.attachmentFileName, error })))
        )
      )
    )
  );

  resendMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessagingActions.resendMessages),
      mergeMap(action =>
        this.communicationService.resendMessages(action.request).pipe(
          map(response => MessagingActions.resendMessagesSuccess({ response })),
          catchError(error => of(MessagingActions.resendMessagesFailure({ error })))
        )
      )
    )
  );

  resendSingleMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessagingActions.resendSingleMessage),
      mergeMap(action =>
        this.communicationService.resendSingleMessage(action.request, action.messageHeaderId).pipe(
          map(response => MessagingActions.resendSingleMessageSuccess({ messageHeaderId: action.messageHeaderId, response })),
          catchError(error => of(MessagingActions.resendSingleMessageFailure({ messageHeaderId: action.messageHeaderId, error })))
        )
      )
    )
  );
}
